<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const polotno = options.polotno || {
        'Наносетка': 'Наносетка',
        'Сетка москитная, Максимальный обзор': 'Максимальный обзор',
        'Сетка москитная, PPE': 'PPE',
        'Сетка москитная, АнтиМОШКА':'АнтиМОШКА',
        'Сетка москитная, Антикошка серебро': 'Антикошка серебро',
        'Сетка москитная, алюминиевая':'Алюминиевая',
        'Сетка москитная, антикошка белое':'Антикошка белое',
        'Сетка москитная, антикошка черное': 'Антикошка черное',
        'Сетка москитная, гипоаллергенная':'Гипоаллергенная',
        'Сетка москитная, стандарт': 'Стандарт',
        'Оконный фильтр Оберег':'Оконный фильтр Оберег'
    }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            // Обычная 1000×1450 Цветной Сетка москитная, Антикошка серебро без перемычки, крючок металлический, металлические уголки, металлическая ручка

            let title = item.title.split(' ', 3),
                inds = item.title.split(', ');

            const itemHeight = +title[1].split('x')[1];
            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            if (item.title.includes('без перемычки')) {
                ind1 = 'Нет';
            } else if (item.title.includes('двумя перемычками')) {
                ind1 = 'Две';
            } else if (item.title.includes('одной перемычкой')) {
                ind1 = 'Одна';
            } else if (itemHeight >= 1800) {
                ind1 = 'Две';
            } else {
                ind1 = 'Одна';
            }
            lintelTouched = true;
            ind2.set(title[2]);

            ind3 = Object.keys(polotno).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            ind4 = inds[2];
            ind5 = inds[3];
            ind6 = inds[4];
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const color = options.color || {
        'Белый':'Белый',
        'Коричневый(RAL8017)':'Коричневый(RAL8017)',
        'Неокрашенный':'Неокрашенный',
        'Антрацит':'Антрацит',
        'Цветной':'Цветной',
    }

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('АлюмПро', '',  '');
        //let options = await network.fetch_ind('АлюмПро');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),
        ind1 = 'Одна', // перемычка: Нет | Одна | Две
        lintelTouched = false,
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Сетка москитная, стандарт', // полотно
        ind4 = 'кронштейн металлический', // кронштейн
        ind5 = 'металлические уголки', // уголки
        ind6 = 'металлическая ручка', // ручки

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    const lintelText = (value) => {
        if (value === 'Нет') {
            return 'без перемычки';
        }
        if (value === 'Две') {
            return 'с двумя перемычками';
        }
        return 'с одной перемычкой';
    };
    const lintelCountOf = (value) => {
        if (value === 'Две') {
            return 2;
        }
        if (value === 'Нет') {
            return 0;
        }
        return 1;
    };

    const changeInd2 = () => {fetchData = fetch($ind2)};
    const changeHeight = _.debounce(() => {
        if (lintelTouched) {
            return;
        }
        const h = +$height;
        if (h >= 1800 && ind1 !== 'Две') {
            ind1 = 'Две';
            toastbox('toast-ind1-two', 3000);
            change();
        } else if (h < 1800 && ind1 === 'Две') {
            ind1 = 'Одна';
            change();
        } else if (h > 1400 && ind1 === 'Нет') {
            ind1 = 'Одна';
            toastbox('toast-ind1', 3000);
            change();
        }
    }, 1000);

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let result = {
            type: 'алюмпро',
            name: 'АлюмПро',
            subname: [
                w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                lintelText(ind1),

            ].join(''),
            title: [
                'АлюмПро', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                lintelText(ind1),

            ].join(''),
            params: {
                ind1: [lintelText(ind1)].join(''),
                ind2: $ind2,
                ind3: ind3,
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture:  options.vStrukture || 41
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();
            let color = item.ind2.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль') && color.includes($ind2.toLowerCase())) {
                kolvo = (((w + 34) * 2 + (h + 34) * 2) / 1000).toFixed(3);
            }

            if (name.includes('шнур фиксирующий') || name.includes('уплотнитель')) {

                    kolvo = (((w + 34 + h + 34) * 2 + 60) / 1000).toFixed(3);

            }

            if (
                (
                    name.includes('сетка москитная') ||
                    name === 'наносетка' ||
                    name === 'оконный фильтр оберег'
                ) && name.toLowerCase().indexOf(ind3.toLowerCase()) >= 0
            ) {
                kolvo = ((w + 34) * (h + 34) / 1000000).toFixed(3);
            }

            if (name.includes('угол') || name.includes('крепление г образные')) {
                kolvo = (4).toFixed(3);
            }

            if (
                name.includes('ручка') && color.includes($ind2.toLowerCase())
            ) {
                kolvo = (1).toFixed(3);
            }

            const lintels = lintelCountOf(ind1);

            if (name.includes('перемычка') && !name.includes('крепление') && color.includes($ind2.toLowerCase())) {
                if (lintels > 0) {
                    kolvo = (lintels * (w - 30) / 1000).toFixed(3);
                }
            }

            if (name.includes('крепление мс перемычки')) {
                if (lintels > 0) {
                    kolvo = (2 * lintels).toFixed(3);
                }
            }



            if (name.includes('работа пс')) {
                if (
                    ind3.toLowerCase().includes('антикошка') ||
                    ind3.toLowerCase().includes('гипоаллергенная') ||
                    ind3.toLowerCase().includes('наносетка')||
                    ind3.toLowerCase().includes('оберег')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }
            else if (name.includes('работа')) {
                if (
                    ind3.toLowerCase().includes('стандарт') ||
                    ind3.toLowerCase().includes('ppe') ||
                    ind3.toLowerCase().includes('антимошка') ||
                    ind3.toLowerCase().includes('максимальный обзор') ||
                    ind3.toLowerCase().includes('нет')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
            if (name.includes('упаковка')) {
                packing_items.push(item);
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000 });
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.edIzmer["кв.м"], null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each Object.entries(polotno) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each Object.entries(color) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Шир., мм ≥ { options.max && options.max.width ? options.max.width : 1500 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.width ? options.max.width : 1500 }" bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Выс., мм ≥ { options.max && options.max.height ? options.max.height : 3000 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.height ? options.max.height : 3000 }" bind:value={$height} use:validate_int={$height} on:change={changeHeight}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Перемычка</label>
                        <select class="form-control form-select" bind:value={ind1} on:change={() => { lintelTouched = true; }}>
                            <option value="Нет">Нет</option>
                            <option value="Одна">Одна</option>
                            <option value="Две">Две</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
<div id="toast-ind1-two" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте от 1800 мм ставятся две перемычки. Количество можно изменить вручную
        </div>
    </div>
</div>

